export default function FilmmakerBiography({ src, name, description }) {
  const hasImage = src && src !== "undefined";

  return (
    <div className="text-gray-300 mb-8">
      <h3 className="text-2xl font-bold text-center mt-4 sm:text-left">
        {description ? "Filmmaker Biography" : "Filmmaker"}
      </h3>
      <div className="flex flex-col gap-8 items-center mt-5 mb-5 sm:flex-row sm:justify-start">
        <div className="flex flex-col">
          {hasImage ? (
            <div
              className="rounded-full overflow-hidden"
              style={{ width: 160 }}
            >
              <img src={src} alt={`${name}-picture`} />
            </div>
          ) : null}
          <h4 className="text-xl font-bold mt-4 self-center">{name}</h4>
        </div>

        <div className={`w-5/6 flex flex-col sm:ml-4`}>
          <div
            className="tenant-injected-html mb-2 text-gray-300 mt-2 text-center sm:text-left"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      </div>
    </div>
  );
}
